import { TransporterDefaultPaymentScheme } from '~/graphql/__generated__/operations/ltms';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const enum DOWNLOAD_TYPE {
  EXISTING_TRANSPORTER_DATA,
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const enum UPLOAD_TYPE {
  CREATE_NEW_TRANSPORTER,
  UPDATE_EXISTING_TRANSPORTER,
}

export const TRANSPORTERS_DOWNLOAD = [
  {
    key: DOWNLOAD_TYPE.EXISTING_TRANSPORTER_DATA,
    label: 'existing_data',
  },
];

export const TRANSPORTER_UPLOAD = [
  {
    key: UPLOAD_TYPE.CREATE_NEW_TRANSPORTER,
    label: 'create_new',
  },
  {
    key: UPLOAD_TYPE.UPDATE_EXISTING_TRANSPORTER,
    label: 'update_existing_data',
  },
];

export const TRANSPORTER_SEARCH_QUERIES = {
  BANK_ACCOUNT_HOLDER: 'searchBankAccountHolder',
  BANK_ACCOUNT_NUMBER: 'searchBankAccountNumber',
  BANK_BRANCH_NAME: 'searchBankBranchName',
  BANK_NAME: 'searchBankName',
  CONTACT_EMAIL: 'searchContactEmailAddress',
  CONTACT_NAME: 'searchContactName',
  CONTACT_PHONE: 'searchContactPhoneNumber',
  TRANSPORTER_ID: 'searchId',
  TRANSPORTER_INITIAL: 'searchInitial',
  TRANSPORTER_NAME: 'searchName',
};

export const TRANSPORTER_FILTER_QUERIES = {
  ACCOUNT_TYPE: 'filterByAccountTypes',
  DOCUMENT_TYPE: 'filterByDocumentTypes',
  STATUS: 'filterByStatuses',
  TYPE: 'filterByTypes',
};

export const ACCOUNT_TYPE = {
  COMPANY: 'COMPANY',
  INDIVIDUAL: 'INDIVIDUAL',
  OPERATOR: 'OPERATOR',
};

export const TRANSPORTER_TYPE = {
  DRIVER_OPERATOR: 'DRIVER_OPERATOR',
  INTERNAL_HIRED_DRIVER: 'INTERNAL_HIRED_DRIVER',
  MOTORIST: 'MOTORIST',
  TRANSPORTER_HIRED_DRIVER: 'TRANSPORTER_HIRED_DRIVER',
  TRUCK_AND_DRIVER_PLUS_UJ: 'TRUCK_AND_DRIVER_PLUS_UJ',
};

export const accountTypeOptions = (tl) => [
  {
    label: tl(`account_types.${ACCOUNT_TYPE.COMPANY}`),
    value: ACCOUNT_TYPE.COMPANY,
  },
  {
    label: tl(`account_types.${ACCOUNT_TYPE.INDIVIDUAL}`),
    value: ACCOUNT_TYPE.INDIVIDUAL,
  },
  {
    label: tl(`account_types.${ACCOUNT_TYPE.OPERATOR}`),
    value: ACCOUNT_TYPE.OPERATOR,
  },
];

export const transporterTypeOptions = (tl) => [
  {
    label: tl(`transporter_types.${TRANSPORTER_TYPE.TRANSPORTER_HIRED_DRIVER}`),
    value: TRANSPORTER_TYPE.TRANSPORTER_HIRED_DRIVER,
  },
  {
    label: tl(`transporter_types.${TRANSPORTER_TYPE.DRIVER_OPERATOR}`),
    value: TRANSPORTER_TYPE.DRIVER_OPERATOR,
  },
  {
    label: tl(`transporter_types.${TRANSPORTER_TYPE.INTERNAL_HIRED_DRIVER}`),
    value: TRANSPORTER_TYPE.INTERNAL_HIRED_DRIVER,
  },
  {
    label: tl(`transporter_types.${TRANSPORTER_TYPE.TRUCK_AND_DRIVER_PLUS_UJ}`),
    value: TRANSPORTER_TYPE.TRUCK_AND_DRIVER_PLUS_UJ,
  },
  {
    label: tl(`transporter_types.${TRANSPORTER_TYPE.MOTORIST}`),
    value: TRANSPORTER_TYPE.MOTORIST,
  },
];

export const DEFAULT_PAYMENT_SCHEME: Record<TransporterDefaultPaymentScheme, string> = {
  PAYMENT_SCHEME_50_50: '50-50',
  PAYMENT_SCHEME_100: '100',
};

// IMPORTANT: NO NEED TO SORT. The order of the object's props is based on the order of template result.
export const TRANSPORTERS_EMPTY_TEMPLATE = ({
  ENABLE_TPT_ONCALL = false,
} = {}) => [
  {
    transporter_ksuid: '',
    transporter_name: '',
    transporter_initial: '',
    transporter_account_type: '',
    transporter_type: '',
    contact_name: '',
    contact_position: '',
    contact_email_address: '',
    contact_phone_number: '',
    pool_gmaps_location: '',
    pool_district_city_province: '',
    pool_full_address: '',
    pool_postal_code: '',
    ...(ENABLE_TPT_ONCALL ? { default_payment_scheme: '' } : {}),
    bank_name: '',
    bank_branch_name: '',
    bank_account_number: '',
    bank_account_holder: '',
    tax_wht: '',
    tax_vat: '',
    skb_ownership: '',
    insurance_start_date: '',
    insurance_end_date: '',
    document_ksuid: '',
    document_type: '',
    document_upload: '',
    document_number: '',
    document_expiry_date: '',
    transporter_status: '',
  },
];
